import Contracts = require("TFS/DistributedTask/Contracts");
export class SharedProjectsPanelData {
    public allProjects: Contracts.ProjectReference[];
    public sharedProjects: Contracts.ProjectReference[];
}
